
















import {Vue, Component,Watch, Prop} from 'vue-property-decorator';
import {State} from 'vuex-class';
import {Mall} from 'supporter';

@Component
export default class MallsTab extends Vue {
  @Prop({required: false, default: false})
  needValidatePage!: boolean;
  @Prop({required: false, default: false})
  isChanged!: boolean;
  @State('malls', {namespace: 'mall'})
  private malls!: Mall[];

  @Watch('$route.query.mallNo', {immediate: false, deep: false})
  async mallNoChanged() {
    this.setLeft();
  }

  private get showTab() {
    let flg = false;
    if (this.malls && this.malls.length && this.malls.length > 1) {
      flg = true;
    }
    return flg;
  }

  private get onIndex() {
    let index = 0;
    this.malls.forEach((mall, idx) => {
      if (mall.mallNo.toString() === this.$route.query.mallNo) {
        index = idx;
      }
    });
    return index;
  }

  private styleLeft = 0;

  private mallClick(mall) {
    if (this.needValidatePage) {
      // is needValidatePage
      if (this.isChanged) {
        let isConfirm = confirm(this.$t('CHANGE_MALL_ALERT') as string);
        if (!isConfirm) {
          return;
        }
      }
    }
    if (this.$route.query.mallNo) {
      if (mall.mallNo === Number(this.$route.query.mallNo)) {
        this.$router.go(0);
        return;
      }
    }
    this.$router.push({
      query: {mallNo: mall.mallNo}
    });
  }
  private btnClick(pattern) {
    if (this.needValidatePage) {
      // is needValidatePage
      if (this.isChanged) {
        let isConfirm = confirm(this.$t('CHANGE_MALL_ALERT') as string);
        if (!isConfirm) {
          return;
        }
      }
    }
    let idx = this.onIndex;

    if (pattern === 'prev') {
      if (idx > 0) {
        idx = idx - 1;
      } else {
        idx = this.malls.length - 1;
      }
    }
    if (pattern === 'next') {
      if (idx < this.malls.length - 1) {
        idx = idx + 1;
      } else {
        idx = 0;
      }
    }
    this.$router.push({
      query: {mallNo: this.malls[idx].mallNo.toString()}
    });
  }
  private setLeft() {
    let listWidth = $('#mall_list_div').width();
    let tempWidth = (this.onIndex + 2) * 112;
    if (listWidth - tempWidth < 0) {
      this.styleLeft = listWidth - tempWidth;
    } else {
      this.styleLeft = 0;
    }
  }
  private mounted() {
    this.setLeft();
  }
}
